import { createConsumer } from "@rails/actioncable";

const getWebSocketURL = () => {
  const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";
  const host = window.location.host; // includes domain + port
  return `${protocol}${host}/cable`;
};

const cable = createConsumer(getWebSocketURL());
export default cable;
